import { FC, Fragment } from 'react';

import { toUpCase } from '../../../utils/misc';
import type { PaymentMessage } from '../types';
import styles from '../FileUploader.module.scss';

interface PaymentNoticesProps {
    messages: PaymentMessage[];
}

const UNPAID_STATUSES = ['не оплачено', 'частково оплачено'];

export const PaymentNotices: FC<PaymentNoticesProps> = ({ messages }) => {
    if (!messages?.length) {
        return null;
    }

    return (
        <div className={styles.noticeList}>
            {messages.map((item, index) => {
                const needPaymentExpertise = UNPAID_STATUSES.includes(
                    item.expertise_status ?? ''
                );
                const needPaymentStateCollection = UNPAID_STATUSES.includes(
                    item.state_collection_status ?? ''
                );
                const needsPayment =
                    needPaymentExpertise || needPaymentStateCollection;

                const hasExpiredStatus =
                    item.not_expired_status !== 'не прострочено' &&
                    item.not_expired_status !== null;

                if (item.is_package && needsPayment) {
                    return (
                        <div
                            className={styles.noticeItem}
                            key={item.number ?? index}
                        >
                            <span>
                                {'Пакетна заявка'} ({item.number} - {item.date}){' '}
                                {needsPayment && toUpCase('не оплачено')}{' '}
                                {hasExpiredStatus &&
                                    toUpCase(item.not_expired_status!)}
                            </span>
                        </div>
                    );
                }

                return (
                    <div
                        className={styles.noticeItem}
                        key={item.number ?? index}
                    >
                        <Fragment>
                            {needsPayment && (
                                <span className={styles.noticeBlock}>
                                    {toUpCase('не оплачено')}
                                </span>
                            )}
                            {hasExpiredStatus && (
                                <span className={styles.noticeBlock}>
                                    {toUpCase(item.not_expired_status!)}
                                </span>
                            )}
                        </Fragment>
                    </div>
                );
            })}
        </div>
    );
};
